import styled from 'styled-components';

export const DashboardWrapper = styled.div`
    height: -webkit-calc(100% - 50px);
    height:    -moz-calc(100% - 50px);
    height:         calc(100% - 50px);
`;